import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "androidFilled"
const AndroidFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18.043 19.29C18.256 19.693 17.931 20.139 17.522 20.117Q17.476 20.115 17.432 20.105 17.388 20.096 17.343 20.078L12 18 6.657 20.078C6.172 20.266 5.713 19.75 5.957 19.29L12 7.875z" />
          <path d="M10.9 3.446C11.431 2.626 12.664 2.653 13.148 3.528L20.07 16.053C20.554 16.926 19.92 18 18.921 18H18.21L11.999 6.272 5.792 18H5.078C4.08 18 3.446 16.927 3.93 16.052L10.851 3.528z" />
        </svg>
      }
    </span>
  )
}
export default AndroidFilledIcon
